import getRuntimeEnv, { getPrefixEnv } from '@utils/env';

const prefixEnv = getPrefixEnv(getRuntimeEnv('APP_ENV'));

const ACCESS_TOKEN = `${prefixEnv}xms-access-token`;
const REFRESH_TOKEN = `${prefixEnv}xms-refresh-token`;

export { ACCESS_TOKEN, REFRESH_TOKEN };
